import { brand } from "./brand";

const config = {
  appName: brand.name,
  baseAppPath: "/app",
  baseApiPath: "/api",
  apiUrl: process.env.REACT_APP_API_URL,
  websiteUrl: process.env.REACT_APP_WEBSITE_URL,
} as const;

export function getApiDomain() {
  const apiUrl = config.apiUrl;

  if (!apiUrl) {
    throw new Error("REACT_APP_API_URL is not defined");
  }

  return apiUrl;
}

export function getWebsiteDomain() {
  const websiteUrl = config.websiteUrl;

  if (!websiteUrl) {
    throw new Error("REACT_APP_WEBSITE_URL is not defined");
  }

  return websiteUrl;
}

export function getBaseAppPath() {
  return config.baseAppPath;
}

export function getBaseApiPath() {
  return config.baseApiPath;
}

export function getAppName() {
  return config.appName;
}
